/* DAVORAQ — interacciones propias (sin librerías) */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.dv-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dv-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Selector de variantes compartido (portada "Elige tu color" y página de producto)
  function initProducts() {
    document.querySelectorAll('[data-dv-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-dv-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-dv-price]');
      var compareEl = root.querySelector('[data-dv-compare]');
      var addBtn = root.querySelector('[data-dv-add]');
      var addLabel = addBtn ? addBtn.querySelector('[data-dv-add-label]') : null;
      var soldText = root.getAttribute('data-dv-soldout-text') || 'Agotado';
      var addText = addLabel ? addLabel.textContent : '';
      var mediaRoot = root.querySelector('[data-dv-tint]');
      var packs = root.querySelector('[data-dv-packs]');
      var qtyInput = root.querySelector('[data-dv-qty]');
      var moneyFormat = root.getAttribute('data-dv-money-format') || '{{amount_with_comma_separator}} €';
      var currentCents = 0;

      function money(cents) {
        cents = Math.round(cents);
        return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
          var n = (cents / 100).toFixed(2).split('.');
          var thousands = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
          switch (key) {
            case 'amount_with_comma_separator': return thousands(n[0], '.') + ',' + n[1];
            case 'amount_no_decimals': return thousands(n[0], ',');
            case 'amount_no_decimals_with_comma_separator': return thousands(n[0], '.');
            case 'amount_with_apostrophe_separator': return thousands(n[0], "'") + '.' + n[1];
            default: return thousands(n[0], ',') + '.' + n[1];
          }
        });
      }

      function renderPacks() {
        if (!packs || !currentCents) return;
        packs.querySelectorAll('.dv-pack').forEach(function (p) {
          var q = parseInt(p.getAttribute('data-qty'), 10);
          var pct = parseFloat(p.getAttribute('data-pct')) || 0;
          var full = currentCents * q;
          // Igual que Shopify: el descuento del pack se redondea por unidad hacia abajo
          var final = (currentCents - Math.floor(currentCents * pct / 100)) * q;
          // Oferta de bienvenida: descuento de pedido que se suma al del pack (redondeo hacia abajo)
          var Wl = window.dvWelcome || {};
          var wPct = (Wl.enabled && Wl.code && Wl.pct > 0) ? Wl.pct : 0;
          if (wPct) final = final - Math.floor(final * wPct / 100);
          var priceEl = p.querySelector('[data-dv-pack-price]');
          var oldEl = p.querySelector('[data-dv-pack-old]');
          var line = p.querySelector('[data-dv-pack-save-line]');
          if (priceEl) priceEl.textContent = money(final);
          if (oldEl) oldEl.textContent = final < full ? money(full) : '';
          if (line) {
            var parts = [];
            if (pct > 0) parts.push('−' + pct + ' % pack');
            if (wPct) parts.push('−' + wPct + ' % bienvenida');
            line.textContent = final < full ? (line.getAttribute('data-label') || 'Ahorras') + ' ' + money(full - final) + ' (' + parts.join(' + ') + ')' : '';
          }
        });
      }

      // Precio de primera compra bajo el precio normal (oferta de bienvenida)
      var W = window.dvWelcome || {};
      var welcomeEl = null;
      var priceBox = root.querySelector('.dv-price');
      if (W.enabled && W.code && W.pct > 0 && priceBox) {
        welcomeEl = document.createElement('div');
        welcomeEl.className = 'dv-offer';
        priceBox.insertAdjacentElement('afterend', welcomeEl);
      }
      function renderWelcomePrice() {
        if (!welcomeEl || !currentCents) return;
        var final = currentCents - Math.floor(currentCents * W.pct / 100);
        welcomeEl.innerHTML =
          '<span class="dv-offer__badge">' + (W.badge || '🎁 Oferta de bienvenida') + ' · −' + W.pct + ' %</span>' +
          '<span class="dv-offer__row"><span class="dv-offer__label">' + (W.priceLabel || 'Tu primera compra:') + '</span>' +
          '<s class="dv-offer__old">' + money(currentCents) + '</s><strong class="dv-offer__new">' + money(final) + '</strong></span>' +
          '<span class="dv-offer__save">' + (W.saveLabel || 'Ahorras') + ' ' + money(currentCents - final) + ' · ' + (W.priceNote || '').replace('{codigo}', W.code) + ' ✓</span>';
        var sticky = document.querySelector('.dv-sticky__price');
        if (sticky) sticky.innerHTML = '<s>' + money(currentCents) + '</s> <strong>' + money(final) + '</strong>';
      }

      if (packs) {
        packs.addEventListener('click', function (ev) {
          var p = ev.target.closest('.dv-pack');
          if (!p) return;
          packs.querySelectorAll('.dv-pack').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          p.setAttribute('aria-pressed', 'true');
          if (qtyInput) qtyInput.value = p.getAttribute('data-qty');
        });
      }

      function selected() {
        var vals = [];
        root.querySelectorAll('[data-dv-option]').forEach(function (group) {
          var on = group.querySelector('[aria-pressed="true"]');
          vals[parseInt(group.getAttribute('data-dv-option'), 10)] = on ? on.getAttribute('data-value') : null;
          var lbl = group.querySelector('[data-dv-option-current]');
          if (lbl && on) lbl.textContent = on.getAttribute('data-value');
        });
        return vals;
      }

      function update() {
        var vals = selected();
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return vals[i] == null || vals[i] === o; });
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (v.cents) { currentCents = v.cents; renderPacks(); renderWelcomePrice(); }
        if (compareEl) compareEl.textContent = v.compare || '';
        if (addBtn) {
          addBtn.disabled = !v.available;
          if (addLabel) addLabel.textContent = v.available ? addText : soldText;
          root.classList.toggle('dv-is-soldout', !v.available);
        }
        if (mediaRoot && v.tint) mediaRoot.style.setProperty('--dv-brush', v.tint);
        if (v.media) {
          var thumb = root.querySelector('[data-dv-thumb][data-media-id="' + v.media + '"]');
          if (thumb) thumb.click();
        }
      }

      root.querySelectorAll('[data-dv-option]').forEach(function (group) {
        group.addEventListener('click', function (ev) {
          var btn = ev.target.closest('[data-value]');
          if (!btn) return;
          group.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          update();
        });
      });

      // Galería
      var main = root.querySelector('[data-dv-main-img]');
      root.querySelectorAll('[data-dv-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          main.src = t.getAttribute('data-src');
          main.alt = t.getAttribute('data-alt') || '';
          if (t.hasAttribute('data-cover')) main.classList.toggle('dv-cover', t.getAttribute('data-cover') === '1');
          root.querySelectorAll('[data-dv-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
        });
      });

      // Cantidad
      var qty = root.querySelector('[data-dv-qty]');
      if (qty) {
        root.querySelectorAll('[data-dv-qty-step]').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-dv-qty-step'), 10));
            qty.value = n;
          });
        });
      }

      update();
    });
  }

  // ---------- Oferta de bienvenida: aplicar el código automáticamente ----------
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    sget: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function applyCode(code) { return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); }
  function hasCode(cart, code) {
    return (cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code.toUpperCase(); });
  }

  function showToast(text) {
    if (!text) return;
    var t = document.createElement('div');
    t.className = 'dv-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = '<span>' + text + '</span><button type="button" aria-label="Cerrar">×</button>';
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    var close = function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 400); };
    t.querySelector('button').addEventListener('click', close);
    setTimeout(close, 7000);
  }

  function initWelcome() {
    var W = window.dvWelcome || {};
    if (!W.enabled || !W.code) return;
    if (/\/(checkouts|account)/.test(location.pathname)) return;
    getCart().then(function (cart) {
      if (hasCode(cart, W.code)) return null;
      return applyCode(W.code);
    }).then(function (applied) {
      if (applied && !store.sget('dv_welcome_toast')) {
        store.sset('dv_welcome_toast', '1');
        showToast((W.toast || '').replace('{codigo}', W.code));
      }
    }).catch(function () {});
  }

  // ---------- Ventana de bienvenida (una vez cada 7 días) ----------
  function initWelcomePopup() {
    var W = window.dvWelcome || {};
    if (!W.enabled || !W.popup || !W.code) return;
    if (/\/(cart|checkouts|account)/.test(location.pathname)) return;
    var last = parseInt(store.get('dv_popup_seen') || '0', 10);
    if (Date.now() - last < 7 * 24 * 3600 * 1000) return;
    // Espera a que el aviso de cookies de Shopify esté cerrado para no taparse
    var cookieBannerOpen = function () {
      var b = document.getElementById('shopify-pc__banner');
      return b && b.offsetParent !== null && getComputedStyle(b).visibility !== 'hidden';
    };
    var tries = 0;
    var waitAndShow = function () {
      if (cookieBannerOpen() && tries++ < 60) { setTimeout(waitAndShow, 1500); return; }
      setTimeout(showPopup, cookieBannerOpen() ? 0 : (tries ? 1200 : 3500));
    };
    waitAndShow();
    function showPopup() {
      if (document.querySelector('.dv-modal')) return;
      store.set('dv_popup_seen', String(Date.now()));
      var m = document.createElement('div');
      m.className = 'dv-modal';
      m.setAttribute('role', 'dialog');
      m.setAttribute('aria-modal', 'true');
      m.setAttribute('aria-label', W.popupEyebrow || 'Regalo de bienvenida');
      m.innerHTML =
        '<div class="dv-modal__box">' +
          '<button type="button" class="dv-modal__close" aria-label="Cerrar">×</button>' +
          '<div class="dv-modal__img"><img src="' + W.popupImage + '" alt=""></div>' +
          '<div class="dv-modal__body">' +
            '<span class="dv-modal__eyebrow">' + (W.popupEyebrow || 'Regalo de bienvenida') + '</span>' +
            '<p class="dv-modal__big">−' + W.pct + ' %</p>' +
            '<p class="dv-modal__sub">' + (W.popupSub || 'en tu primera compra') + '</p>' +
            '<p class="dv-modal__applied">✓ ' + (W.popupApplied || 'Ya lo hemos aplicado por ti') + '</p>' +
            '<a class="dv-btn dv-modal__cta" href="' + (W.productUrl || '/products/davoraq-sonic') + '">' + (W.popupButton || 'Ver mi oferta') + '</a>' +
            '<p class="dv-modal__note">' + (W.popupNote || 'Código {codigo}').replace('{codigo}', W.code) + '</p>' +
          '</div>' +
        '</div>';
      document.body.appendChild(m);
      requestAnimationFrame(function () { m.classList.add('is-in'); });
      var close = function () { m.classList.remove('is-in'); setTimeout(function () { m.remove(); }, 350); document.removeEventListener('keydown', onKey); };
      var onKey = function (e) { if (e.key === 'Escape') close(); };
      document.addEventListener('keydown', onKey);
      m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('.dv-modal__close')) close(); });
      if (location.pathname.indexOf(W.productUrl) === 0) {
        m.querySelector('.dv-modal__cta').addEventListener('click', function (e) { e.preventDefault(); close(); });
      }
    }
  }

  // ---------- Barra fija de compra en móvil (página de producto) ----------
  function initStickyBar() {
    var W = window.dvWelcome || {};
    if (W.stickyBar === false) return;
    var pdp = document.querySelector('.dv-pdp [data-dv-add]');
    if (!pdp) return;
    var titleEl = document.querySelector('.dv-pdp__title');
    var bar = document.createElement('div');
    bar.className = 'dv-sticky';
    bar.innerHTML = '<div class="dv-sticky__info"><span class="dv-sticky__title">' + (titleEl ? titleEl.textContent.split('–')[0].trim() : '') + '</span>' +
      '<span class="dv-sticky__price"></span></div><button type="button" class="dv-btn dv-sticky__btn"></button>';
    document.body.appendChild(bar);
    var btn = bar.querySelector('button');
    var syncLabel = function () {
      var label = pdp.querySelector('[data-dv-add-label]');
      btn.textContent = label ? label.textContent : 'Añadir al carrito';
      btn.disabled = pdp.disabled;
    };
    syncLabel();
    btn.addEventListener('click', function () { pdp.click(); });
    var priceEl = document.querySelector('.dv-pdp [data-dv-price]');
    var stickyPrice = bar.querySelector('.dv-sticky__price');
    if (!(W.enabled && W.pct > 0) && priceEl) stickyPrice.textContent = priceEl.textContent;
    var ticking = false;
    var check = function () {
      ticking = false;
      var r = pdp.getBoundingClientRect();
      var show = r.bottom < 0;
      if (show !== bar.classList.contains('is-in')) { bar.classList.toggle('is-in', show); syncLabel(); }
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
    document.dispatchEvent(new Event('dv:sticky-ready'));
  }

  // ---------- Casilla para introducir códigos en el carrito ----------
  function buildCodeBox() {
    var W = window.dvWelcome || {};
    var box = document.createElement('div');
    box.className = 'dv-codebox';
    box.innerHTML =
      '<label class="dv-codebox__label">' + (W.cartLabel || '¿Tienes un código de descuento?') + '</label>' +
      '<div class="dv-codebox__row"><input type="text" class="dv-codebox__input" autocomplete="off" placeholder="' + (W.code || 'CÓDIGO') + '">' +
      '<button type="button" class="dv-codebox__btn">' + (W.cartButton || 'Aplicar') + '</button></div>' +
      '<p class="dv-codebox__msg" aria-live="polite"></p>';
    var input = box.querySelector('input');
    var btn = box.querySelector('button');
    var msg = box.querySelector('.dv-codebox__msg');
    function refreshMsg() {
      getCart().then(function (cart) {
        var ok = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        msg.className = 'dv-codebox__msg' + (ok.length ? ' is-ok' : '');
        msg.textContent = ok.length ? (W.cartApplied || 'Código aplicado:') + ' ' + ok.join(', ') + ' ✓' : '';
      }).catch(function () {});
    }
    function submit() {
      var code = (input.value || '').trim().toUpperCase();
      if (!code) return;
      btn.disabled = true;
      var previous = [];
      getCart().then(function (before) {
        previous = (before.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        return applyCode(code);
      }).then(getCart).then(function (cart) {
        var found = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
        if (found && found.applicable) { location.reload(); return null; }
        msg.className = 'dv-codebox__msg is-error';
        msg.textContent = W.cartInvalid || 'Este código no es válido o no se puede aplicar a tu carrito.';
        btn.disabled = false;
        // Si el código no vale, se recupera el descuento que ya tenía (p. ej. el de bienvenida)
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: previous.filter(function (c) { return c.toUpperCase() !== code; }).join(',') })
        });
      }).catch(function () { btn.disabled = false; });
    }
    btn.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
    refreshMsg();
    return box;
  }
  function injectCodeBoxes() {
    var W = window.dvWelcome || {};
    if (W.cartBox === false) return;
    var targets = document.querySelectorAll('.cart-drawer__footer, #main-cart-footer .cart__blocks');
    targets.forEach(function (t) {
      if (t.querySelector('.dv-codebox')) return;
      if (t.closest('.is-empty')) return;
      t.insertBefore(buildCodeBox(), t.firstChild);
    });
  }
  function initCodeBoxes() {
    injectCodeBoxes();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; injectCodeBoxes(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initStickyBar();
    initProducts();
    initWelcome();
    initWelcomePopup();
    initCodeBoxes();
  });
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initProducts();
  });
})();
